import { Notyf } from 'notyf';

function toast() {
  const notyf = new Notyf({
    duration: 200000,
    dismissible: true,
    position: {
      x: 'right',
      y: 'bottom',
    },
    types: [
      {
        type: 'success',
        icon: false,
      },
    ],
  });

  notyf.success("<strong>You've copied this link!</strong>");
}

function socialMedia() {
  const sm = document.querySelectorAll('.c-social-share .c-social__link');
  if (sm) {
    [].forEach.call(sm, (item) => {
      const href = item.getAttribute('href');
      const linkTo = item.getAttribute('data-js-linkto');
      const copyInput = item.querySelector('.c-social__link-hidden');
      const hasCopyLink = item.hasAttribute('data-js-copy');

      !hasCopyLink &&
        item.setAttribute(
          'href',
          href.replace('[windowUrl]', linkTo || window.location),
        );

      hasCopyLink &&
        copyInput.setAttribute(
          'value',
          copyInput.value.replace('[windowUrl]', window.location),
        );

      hasCopyLink &&
        item.addEventListener(
          'click',
          async () => {
            if (!navigator.clipboard) {
              // Clipboard API not available
              return;
            }
            const text = copyInput.value;
            try {
              await navigator.clipboard.writeText(text);
              // alert('Copied to clipboard');
              toast();
            } catch (err) {
              console.error('Failed to copy!', err);
            }
          },
          false,
        );
    });
  }
}

export function init() {
  socialMedia();
}
